<template>
  <div class="boxbox">
    <div class="screening">
      <div class="materialBox">
        <p class="titlebx">物资类型</p>
        <span
          class="only1  onlyprovince1 "
          :class="materialflag ? 'provinceactive' : ''"
          @click="onmaterialfun"
        >
          不限
        </span>
        <div class="material">
          <p
            v-for="(item, index) in materiallist"
            :key="index"
            class="only"
            :class="item.flag ? 'onlyactive' : ''"
            @click="onMaterial(item)"
          >
            {{ item.codeName }}
          </p>
        </div>
      </div>
      <div class="province">
        <p class="onlyprovince title">所在省份</p>
        <p class="onlyprovince unlimited">
          <span
            class=" onlyprovince1"
            :class="provinceflag ? 'provinceactive' : ''"
            @click="onprovincefun"
            >不限</span
          >
        </p>
        <div class="provincebox ">
          <p
            v-for="(item, index) in address"
            :key="index"
            class="onlyprovince onlyprovince1"
            :class="item.flag ? 'provinceactive' : ''"
            @click="onMaterial(item)"
          >
            {{ item.codeRemark }}
          </p>
        </div>
      </div>

      <div class="ruleForm">
        <el-form
          :model="ruleForm"
          status-icon
          ref="ruleForm"
          label-width="96px"
          :inline="true"
          size="mini"
          label-suffix=":"
        >
          <el-form-item label="发布单位" prop="pass" class="inputonly">
            <el-input
              v-model="ruleForm.compName"
              autocomplete="off"
              class="inputonly1"
            ></el-input>
          </el-form-item>
          <el-form-item label="公告标题" prop="checkPass" class="inputonly">
            <el-input
              v-model="ruleForm.title"
              autocomplete="off"
              class="inputonly1"
            ></el-input>
          </el-form-item>
          <el-form-item label="公告编号" prop="age" class="inputonly">
            <el-input
              v-model.number="ruleForm.code"
              class="inputonly1"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item label="物资描述" prop="age" class="inputonly">
            <el-input
              v-model.number="ruleForm.mateName"
              class="inputonly1"
            ></el-input>
          </el-form-item> -->

          <div class="submit">
            <p class="cancel" @click="onClear">清除</p>
            <p class="query" @click="onQuery">查询</p>
          </div>
        </el-form>
      </div>
    </div>
    <div class="bidding">
      <div class="biddinglist">
        <div v-for="(item, index) in newProduct" :key="index">
          <div class="biddinglistsome " @click="goDetail(item.id)">
            <div class="biddinglistsomeimg">
              <img :src="item.imageUrl" style="height:150px;width:255px" />
              <div class="time">
                {{ item.tipText }}:
                <template v-if="item.myTypes === 'biding'">
                  <MyCountDown
                    type="biding"
                    :startTime="item.systemDate"
                    :endTime="item.bidEndTime"
                  ></MyCountDown>
                </template>
                <template v-else>
                  <MyCountDown
                    :startTime="item.systemDate"
                    :endTime="item.bidStartTime"
                  ></MyCountDown>
                </template>
              </div>
              <img :src="item.bidImg" class="biddinglistsomeimgclass" />
            </div>
            <div class="biddinglistsomeintru">
              <p class="biddinglistsomeintrutitle fbold">
                {{ item.title }}
              </p>
              <p class="text ">公告编号 : {{ item.code }}</p>
              <p class="textprice" v-if="item.disposalCode != 2">
                当前价 :
                <span class="price">{{
                  item.maxQuotePrice ? item.maxQuotePrice : item.startPrice
                }}</span>
                <span v-if="item.bidCode !== '10'">
                  {{ item.unitName ? `元/${item.unitName}` : '元' }}</span
                >
                <span v-else>元</span>
              </p>

              <p
                v-if="item.disposalCode === '1' || item.bidCodeMate === '10'"
                :class="[
                  'text',
                  'textcolor',
                  item.disposalCode == 2 ? 'textprice' : ''
                ]"
              >
                开盘价 :
                <span
                  :class="item.disposalCode == 2 ? 'price' : 'textcolor1'"
                  >{{ item.startPrice }}</span
                >
                <span v-if="item.bidCode !== '10'">
                  {{ item.unitName ? `元/${item.unitName}` : '元' }}</span
                >
                <span v-else>元</span>
              </p>
              <template
                v-if="item.disposalCode === '2' && item.bidCodeMate === '05'"
              >
                <p class="fenx">多物资分项报价，请查看详情</p>
              </template>
              <p class="text textcolor" v-if="item.disposalCode === '1'">
                出价次数 :
                <span class="textcolor1">{{ item.countQuotePrice }}</span>
              </p>
              <div class="location ">
                <p>
                  <img
                    src="../../assets/imgs/Vector2.png"
                    alt=""
                    style="margin-right:4px;height:14px;width:11.8px;"
                  />
                  <span class="locationsome">{{ item.proviceName }}</span>
                </p>
                <p>
                  <span class="locationsome"
                    >围观次数 :
                    <span class="textcolor1">{{ item.readTimes }}</span></span
                  >
                </p>
              </div>
            </div>
          </div>
          <!-- 
          <div class="biddinglistsome notice" @click="goDetail(item.id)">
            <div class="biddinglistsomeimg">
              <img
                :src="item.imageUrl"
                alt=""
                style="height:150px;width:255px"
              />
              <div class="time">
                距竞价结束:<count-downnew
                  :endTime="item.bidStartTime"
                  :startTime="strDate"
                ></count-downnew>
              </div>
              <img
                src="../../assets/imgs/foretell.png"
                alt=""
                class="biddinglistsomeimgclass"
                style="height:30px;width:76px"
              />
            </div>
            <div class="biddinglistsomeintru noticebottom">
              <p class="biddinglistsomeintrutitle">
                {{ item.title }}
              </p>
              <p class="text">公告编号 : {{ item.bidCode }}</p>
              <p class="textprice">
                开盘价 : <span class="price">{{ item.bidCode }}</span
                ><span> 元/吨</span>
              </p>
              <div class="location locationsome1 other">
                <p>
                  <img
                    src="../../assets/imgs/Vector2.png"
                    alt=""
                    style="margin-right:4px;height:14px;width:11.8px;"
                  />
                  <span class="locationsome">{{ item.proviceName }}</span>
                </p>
                <p>
                  <span class="locationsome"
                    >围观次数 :
                    <span class="textcolor1">{{ item.proviceName }}</span></span
                  >
                </p>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div v-if="newProduct.length == 0" style="text-align: center">
        <img src="@/assets/imgs/isNoData.jpg" alt="" />
      </div>
      <div>
        <el-pagination
          background
          layout="prev, pager, next,total,jumper"
          :total="num"
          :page-size="12"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          prev-text="上一页"
          next-text="下一页"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config'
export default {
  props: {
    valarr: {
      type: Array
    },
    activewat: {
      type: Number
    },
    inputV: {
      type: String
    },
    propName: {
      // type: number,
      // default: 0
    }
  },
  data() {
    return {
      num: null,
      newProduct: [],
      resultunlimitedflag: true,
      materialflag: true,
      provinceflag: true,
      materiallist: [],
      biddingconditionlist: [
        { name: '成交', flag: false },
        { name: '未成交', flag: false }
      ],
      address: [],
      ruleForm: {
        compName: '',
        title: '',
        code: ''
        // mateName: ''
      },
      provinces: '',
      param: {
        proviceCode: '',
        bidSort: 'bidStartSort',
        mateIds: '',
        isDeal: 0,
        pageSize: 12,
        pageNum: 1
      }
    }
  },
  computed: {
    type() {
      return this.$route.query.type
    }
  },
  watch: {
    '$route.query.provinces': {
      handler(val) {
        console.log(val)
        if (val) {
          this.provinces = val
          this.param.proviceCode = val
          this.provinceflag = false
        }
      },
      deep: true,
      immediate: true
    },
    '$route.query.mateId': {
      handler(val) {
        if (val) {
          this.param.mateIds = val
          this.materialflag = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.getNoticeList()
    this.currentTime()
    this.getProvinces()
    this.getTypes()
  },
  methods: {
    onprovincefun() {
      if (!this.provinceflag) {
        this.provinceflag = true
        this.address.map(item => {
          item.flag = false
        })
        this.param.proviceCode = ''
      }
      this.getNoticeList()
    },
    // 获取物资分类
    async getTypes() {
      const { data } = await this.$api.mySubscribe.getMaterial({
        classCode: 'WZCZ_MATES',
        higherCode: 0
      })
      this.materiallist = data.map(item => {
        return {
          ...item,
          flag: false
        }
      })
      const mateId = this.$route.query.mateId
      if (mateId) {
        const obj = this.materiallist.find(item => item.codeCode === mateId)
        obj.flag = true
      }
    },
    async getNoticeList() {
      let data = await this.$api.notice.getNoticeList(this.param)
      if (data && data.length != 0) {
        const list = data.data.map(item => {
          item.imageUrl = config.STATIC_URL + item.imageUrl
          // bidCode '0'竞价预告 '1'正在竞价 '2'竞价结束
          if (item.bidCode === '0') {
            item.startTime = item.bidStartTime
            item.bidImg = require('../../assets/imgs/foretell.png')
            item.tipText = '距竞价开始'
            item.myTypes = ''
          }
          if (item.bidCode === '1') {
            item.startTime = this.currentTime()
            item.bidImg = require('../../assets/imgs/30px.png')
            item.tipText = '距竞价结束'
            item.myTypes = 'biding'
          }
          if (item.bidCode === '2') {
            item.startTime = item.bidStartTime
            item.bidImg = require('../../assets/imgs/30px 3.png')
            item.tipText = '成交时间'
            item.myTypes = ''
          }
          return item
        })
        this.newProduct = list
        this.num = Number(data.total)
      } else {
        this.newProduct = []
        this.num = 0
      }
    },
    /**
     * 获取当前时间
     */
    currentTime() {
      var date = new Date()
      var year = date.getFullYear() //月份从0~11，所以加一
      var dateArr = [
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      ]
      //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
      for (var i = 0; i < dateArr.length; i++) {
        if (dateArr[i] >= 1 && dateArr[i] <= 9) {
          dateArr[i] = '0' + dateArr[i]
        }
      }
      var strDate =
        year +
        '-' +
        dateArr[0] +
        '-' +
        dateArr[1] +
        ' ' +
        dateArr[2] +
        ':' +
        dateArr[3] +
        ':' +
        dateArr[4]

      return strDate
    },
    onmaterialfun() {
      if (!this.materialflag) {
        this.materialflag = true
        this.materiallist.map(item => {
          item.flag = false
        })
        this.param.mateIds = ''
      }
      this.getNoticeList()
    },
    onMaterial(item) {
      console.log(item)
      item.flag = !item.flag
      let ids = []
      this.provinceflag = !this.address.some(item => {
        return item.flag
      })
      this.address.map(item => {
        if (item.flag) {
          ids.push(item.cityCode)
        }
      })

      const applyIds = ids.join(',')
      console.log(applyIds)
      this.param.proviceCode = applyIds
      let codes = []
      this.materialflag = !this.materiallist.some(item => {
        return item.flag
      })
      this.materiallist.map(item => {
        if (item.flag) {
          codes.push(item.codeCode)
        }
      })

      this.param.mateIds = codes.join(',')
      this.param = {
        ...this.param,
        ...this.ruleForm
      }
      console.log(this.param)
      this.getNoticeList()
    },
    onClear() {
      this.ruleForm.compName = ''
      this.ruleForm.title = ''
      this.ruleForm.code = ''
      this.param.proviceCode = ''
      this.param.mateIds = ''
      this.param = {
        ...this.param,
        ...this.ruleForm
      }
      this.onmaterialfun()
      this.onprovincefun()
    },
    onQuery() {
      this.param.pageNum = 1
      this.param = {
        ...this.param,
        ...this.ruleForm
      }
      console.log(this.param)
      this.getNoticeList()
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.param.pageNum = val
      this.getNoticeList()
    },
    // 跳转详情
    goDetail(id) {
      let routerJump = this.$router.resolve({
        path: '/home/noticeInfo',
        query: { id }
      })
      window.open(routerJump.href, '_blank')
    },
    // 首页获取地点数据
    async getProvinces() {
      let res = await this.$api.notice.getProvinces()
      res.data.map(item => {
        if (item.cityCode == this.$route.query.provinces) {
          item.flag = true
        } else {
          item.flag = false
        }
      })
      this.address = res.data
    }

    // currentPage1: 5,
    // currentPage2: 5,
    // currentPage3: 5,
    // currentPage4: 4
  }
}
</script>
<style lang="less" scoped>
.boxbox {
  background: transparent !important;
}
.screening {
  background: #ffffff;
  width: 1200px;
  //   min-height: 300px;

  padding: 20px;
  margin-bottom: 20px;
  margin-top: 20px;
  .materialBox {
    display: flex;
    border-bottom: 1px solid #dcdcdc;
    .titlebx {
      margin-right: 20px;
      min-width: 60px;
    }
    .only {
      min-width: 40px;
      cursor: pointer;
      margin-bottom: 20px;
    }
    .only1 {
      margin: -4px 13px 0 -4px;
      min-width: 40px;
      height: 25px;
      cursor: pointer;
    }
  }
  .material {
    padding-bottom: 2px;
    display: flex;
    flex-wrap: wrap;
    .title {
      margin-right: 20px;
    }
    .only {
      margin-right: 20px;
      cursor: pointer;
      font-family: 'Source Han Sans CN';
      font-style: normal;
      font-weight: 350;
      font-size: 14px;
      line-height: 14px;
      /* identical to box height, or 100% */

      /* 灰色/文字/Gy8-#333333 */

      color: #333333;
    }
    .only:hover {
      color: #2587ff;
    }
  }
  .province {
    min-height: 88px;
    border-bottom: 1px solid #dcdcdc;
    padding-bottom: 20px;
    display: flex;
    // padding-top: 20px;
    // flex-wrap: wrap;
    .title {
      margin-right: 10px;
      margin-top: 20px;
      display: inline-block;
    }
    .only {
      display: inline-block;
      margin-right: 20px;
      cursor: pointer;
      font-family: 'Source Han Sans CN';
      font-style: normal;
      font-weight: 350;
      font-size: 14px;
      line-height: 14px;
      /* identical to box height, or 100% */

      /* 灰色/文字/Gy8-#333333 */

      color: #333333;
      margin-bottom: 20px;
    }
    .only:hover {
      color: #2587ff;
    }
    .provincebox {
      display: flex;
      flex-wrap: wrap;
      display: inline-block;
      width: 1030px;
      //   background: #333333;
    }
  }
}
.some {
  padding-top: 20px;
  //   margin-bottom: 20px;
}
/deep/.inputonly {
  .el-form-item__label {
    font-family: 'Source Han Sans CN';
    font-style: normal;
    font-weight: 350;
    font-size: 14px;
    line-height: 28px;
    /* identical to box height, or 100% */

    /* 灰色/文字/Gy8-#333333 */

    color: #333333;
  }
}
/deep/.inputonly1 {
  .el-input__inner {
    width: 280px;
    height: 30px;
    border-radius: 0px;
  }
}
.submit {
  display: flex;
  justify-content: flex-end;
  margin-right: 12px;
  .cancel {
    display: inline-block;
    width: 80px;
    height: 30px;
    border: 1px solid #d9d9d9;
    margin-right: 20px;
    font-family: 'Source Han Sans CN';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 30px;
    /* identical to box height, or 100% */

    /* 灰色/文字/Gy8-#333333 */

    color: #333333;
    text-align: center;
    cursor: pointer;
  }
  .query {
    display: inline-block;
    width: 80px;
    cursor: pointer;
    height: 30px;
    background: #2587ff;
    font-family: 'Source Han Sans CN';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 30px;
    /* identical to box height, or 100% */

    /* 灰色/文字/Gy8-#333333 */

    color: #ffffff;
    text-align: center;
  }
}
/deep/.el-input__inner {
  border: 1px solid #dcdfe6 !important;
  font-family: MicrosoftYaHeiLight;
}
.onlyactive {
  color: #2587ff !important;
}
.provinceactive {
  background: #2587ff;
  border-radius: 16px;
  color: #ffffff !important;
}
.onlyprovince {
  display: inline-block;

  //   margin-right: 16px;
  cursor: pointer;
  font-family: 'Source Han Sans CN';
  font-style: normal;
  font-weight: 350;
  font-size: 14px;
  line-height: 14px;
  /* identical to box height, or 100% */

  /* 灰色/文字/Gy8-#333333 */

  color: #333333;
}
.onlyprovince1 {
  padding: 4px 5px;
  margin-top: 15px;
  margin-left: 10px;
}
.unlimited {
  padding-top: 20px;
}
/deep/.more {
  position: static !important;
}
/deep/.el-pagination {
  text-align: right !important;
}
/deep/.active {
  background-color: #2587ff !important;
  color: #2587ff !important;
}
/deep/.number {
  border: 1px solid #d9d9d9;
  background-color: #ffffff !important;
}
/deep/.number:hover {
  color: #2587ff !important;
}
/deep/.el-icon-d-arrow-right {
  color: #2587ff !important;
}
/deep/.el-icon-d-arrow-left {
  color: #2587ff !important;
}
/deep/.el-pager li.active + li {
  border: 1px solid #d9d9d9;
}
/deep/.btn-prev {
  border: 1px solid #d9d9d9;
  padding: 0 9px 0 9px !important;
  background-color: #ffffff !important;
}
/deep/.btn-next {
  border: 1px solid #d9d9d9;
  padding: 0 9px 0 9px !important;
  background-color: #ffffff !important;
}

/deep/.btn-quicknext {
  background-color: #ffffff !important;
}
/deep/.btn-quickprev {
  background-color: #ffffff !important;
}
.ruleForm {
  padding-top: 20px;
}
.boxbox1 {
  min-height: 200px;
}
.bidding {
  min-height: 396px;
  background: white;
  width: 100%;
  margin-top: 20px;
  padding-bottom: 20px;

  // padding: 10px;
  .biddingtitle {
    height: 60px;
    width: 100%;
    border-bottom: 2px solid #2587ff;
    display: flex;
    align-items: center;
    justify-items: center;
    align-items: center;
    padding: 0 20px 0 20px;
    justify-content: space-between;
    // padding: 20px;
    //   font-family: Source Han Sans CN;
    font-family: 'Source Han Sans CN';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    /* identical to box height, or 100% */

    /* 灰色/文字/Gy8-#333333 */

    color: #333333;

    .numbermore {
      font-family: 'Source Han Sans CN';
      font-style: normal;
      font-weight: 400;
      font-size: 24px;
      line-height: 24px;

      color: #2587ff;

      display: inline-block;
      margin-left: 20px;
    }
    .biddingmore {
      cursor: pointer;
      font-family: 'Source Han Sans CN';
      font-style: normal;
      font-weight: 350;
      font-size: 16px;
      line-height: 16px;
      color: #0064c8;
      float: right;
    }
  }
  .biddinglist {
    width: 100%;
    display: flex;
    flex-wrap: wrap;

    .biddinglistsome {
      cursor: pointer;
      height: 365px;
      border: 1px solid #d9d9d9;
      margin-left: 20px;
      margin-top: 20px;
      .biddinglistsomeimg {
        height: 160px;
        padding: 10px 10px 0 10px;
        position: relative;
        .time {
          height: 30px;
          background: #333333;
          opacity: 0.8;
          margin-top: -30px;
          font-family: 'Source Han Sans CN';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 30px;
          text-align: center;
          color: #ffffff;
          .count-downnew {
            color: #ffffff;
          }
        }
        .biddinglistsomeimgclass {
          position: absolute;
          top: 20px;
          left: -1px;
          height: 30px;
        }
      }
      .biddinglistsomeintru {
        width: 275px;
        height: 205px;
        padding: 10px;
        position: relative;
        .biddinglistsomeintrutitle {
          font-family: 'Source Han Sans CN';
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 16px;

          color: #333333;
          width: 200px;
          display: block;
          width: 200px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-bottom: 5px;
        }
        .text {
          font-family: 'Source Han Sans CN';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 24px;
          color: #333333;
        }
        .fbold {
          font-weight: bold;
        }
        .textcolor {
          color: #666666;
        }
        .textcolor1 {
          font-family: 'Source Han Sans CN';
          font-style: normal;
          font-weight: bold;
          font-size: 14px;
          line-height: 14px;
          color: #333333;
        }
        .location {
          height: 36px;
          width: 255px;
          border-top: 1px solid #dcdcdc;
          margin-top: 15px;
          display: flex;
          align-items: center;
          justify-items: center;
          align-items: center;
          justify-content: space-between;
          position: absolute;
          bottom: 0;
          .locationsome {
            font-family: 'Source Han Sans CN';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 12px;
            color: #666666;
            vertical-align: middle;
          }
        }
        .textprice {
          font-family: 'Source Han Sans CN';
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 50px;
          color: #333333;
          .price {
            font-family: 'Source Han Sans CN';
            font-style: normal;
            font-weight: bold;
            font-size: 20px;
            line-height: 20px;
            color: #f0250f;
          }
        }
      }
    }
  }
}
.other {
  margin-top: 60px !important;
}
.onlyprovince:hover {
  color: #2587ff;
}
.fenx {
  color: #2587ff;
  font-size: 16px;
  font-weight: 500;
  line-height: 51px;
  text-align: center;
}
</style>
